module.exports = __webpack_public_path__ + "static/media/trash.6c015a73.svg";